// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Ajouter aux favoris, TAILLE 3 du « + » : la plus affirmee des trois. Meme
 * etoile que `IconFavAdd`. Source `fav-ad-bigbig.svg`.
 */
export const IconFavAddBigBig = createCustomIcon(
  'IconFavAddBigBig',
  '0 0 304.85 326.31',
  <>
    <polygon
      fill="currentColor"
      points="304.85 223.79 304.85 264.86 243.55 264.93 243.3 326.31 202.41 326.16 202.27 264.98 140.95 264.74 140.95 223.91 202.26 223.68 202.41 162.45 243.36 162.45 243.53 223.74 304.85 223.79"
    />
    <polygon
      fill="currentColor"
      points="121.02 219.93 121.02 190.04 75.43 210.44 86.88 151.87 51.37 116.14 101.75 100.54 129.07 54.13 156.17 100.36 206.74 116.14 177.96 145.12 216.57 145.12 258.12 103.5 174.42 77.57 129.07 0 83.78 77.51 0 103.48 57.29 160.89 38.13 257.2 121.02 219.93"
    />
  </>,
);
